export default __webpack_public_path__ + "static/media/IMG_1619.4351bb7f.jpg";